import styled from 'styled-components';

const YearResultsWrapper = styled.div``;

YearResultsWrapper.displayName = 'YearResultsWrapper';

export default YearResultsWrapper;
